import React from 'react';
import { resolveMenuTabComponent } from '../shared/navigation/menuTabResolver';
import { useMenuTabFlowKind } from '../data/domains/config';
import OrderScreen from '../orders/OrderScreen';

/** Auth stack Order — guest checkout landing on main. */
export function AuthOrderScreenRoute() {
  return <OrderScreen guest_checkout_landing="main" />;
}

/** Auth stack DailyMenuFlow — shares menu fork with tab bar via menu_page_style app_config. */
export function AuthDailyMenuScreenRoute() {
  const menu_tab_flow_kind = useMenuTabFlowKind();
  const Screen = resolveMenuTabComponent(menu_tab_flow_kind);
  return <Screen />;
}
